export const sortOrders = {
  asc: 'ASC',
  desc: 'DESC',
};

export const COUNT_PRODUCT_PER_PAGE = 20;

export const DEFAULT_PAGE_NUMBER = 1;
